import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import CareerCertificateModule from 'bundles/unified-description-page-common/components/modules/credits/CareerCertificateModule';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';

import _t from 'i18n!nls/xdp';

type Props = {
  pageData?: ConsumerCoursePageFieldsFragment | EnterpriseCoursePageFieldsFragment;
  config?: {
    title?: string;
  };
};

const CareerCertificateModuleRenderer = ({ config, pageData }: Props) => {
  // If VERIFIED_CERTIFICATE isn't listed in the `certificates` field, do not render the module
  if (pageData?.certificates && !pageData?.certificates?.includes('VERIFIED_CERTIFICATE')) {
    return null;
  }

  return (
    <CareerCertificateModule
      title={config?.title || _t('Earn a career certificate')}
      description={
        <React.Fragment>
          <Typography2 component="p" variant="bodyPrimary">
            {_t('Add this credential to your LinkedIn profile, resume, or CV')}
          </Typography2>
          <Typography2 component="p" variant="bodyPrimary">
            {_t('Share it on social media and in your performance review')}
          </Typography2>
        </React.Fragment>
      }
    />
  );
};
export default CareerCertificateModuleRenderer;
